export async function fetchDailyGame() {
  const response = await fetch(`/api/daily?t=${Date.now()}`, {
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });

  const text = await response.text();
  let data = null;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (error) {
    throw new Error(`Ogiltigt svar från /api/daily: ${text || "tomt svar"}`);
  }

  if (!response.ok) {
    throw new Error(data?.error || `Kunde inte ladda dagens spel (${response.status})`);
  }

  return data;
}

export async function submitGuessRequest({ sausageId, attemptNumber }) {
  const response = await fetch(`/api/guess?t=${Date.now()}`, {
    method: "POST",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
    body: JSON.stringify({ sausageId, attemptNumber }),
  });

  const text = await response.text();
  let data = null;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (error) {
    throw new Error(`Ogiltigt svar från /api/guess: ${text || "tomt svar"}`);
  }

  if (!response.ok) {
    throw new Error(data?.error || `Kunde inte skicka gissningen (${response.status})`);
  }

  return data;
}